export const sliceText = (text, length = 16) => {
    if (!text) {
        return '';
    }
    if (text.length > length) {
        return text.slice(0, length).concat('...');
    }
    return text;
};
